import { render, staticRenderFns } from "./category-circle.vue?vue&type=template&id=72d19d36&scoped=true&lang=pug&"
import script from "./category-circle.vue?vue&type=script&lang=ts&"
export * from "./category-circle.vue?vue&type=script&lang=ts&"
import style0 from "./category-circle.vue?vue&type=style&index=0&id=72d19d36&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d19d36",
  null
  
)

export default component.exports